import gsap from 'gsap';
import toggle from '../helpers/class-toggle';

export default () => {
	initSelects()
}

function initSelects() {
	const selectEls = document.querySelectorAll('.select');

	selectEls.forEach(function(select) {
		initSelect(select);
	});
}

function initSelect(select) {
	const holder = select.querySelector('.select__holder');
	const list = select.querySelector('.select__list');
	const options = select.querySelectorAll('.select__list-item');
	const label = select.querySelector('.js-size-name');
	const OPTION_ACTIVE = 'select__list-item--active';

	holder.addEventListener('click', (e) => {
		if (e.target.classList.contains('js-add-to-bag')) return;

		setZindex(holder);

		setState(select, -1);
	});

	// close on esc
	document.addEventListener('keydown', (e) => {
		if (e.keyCode === 27) {
			setState(select, false);
		}
	});

	const wrapper = document.querySelector('.mini-bag__top');

	wrapper?.addEventListener('scroll', () => {
		const select = wrapper.querySelector('.select--opened');

		if(!select) return;
		setState(select, false);
	});

	options.forEach(function(option) {
		option.addEventListener('click', (e) => {

			const isChanged = toggle(options, option, OPTION_ACTIVE);
			if (isChanged) {
				const prefix = select.dataset.label || '';

				label.innerText = prefix + option.querySelector('span').innerText;

				const event = new CustomEvent("update", { detail: option });
				select.dispatchEvent(event);
			}

			setState(select, false);
		});
	});
}

function toggleFixedSelect(select, isActive) {
	const miniBag = select.closest('.js-cart');
	if(!miniBag) return;

	const parentElement = document.querySelector('.sidemenu');
	const inner = select.querySelector('.select__inner');

	const rect = select.getBoundingClientRect();
	const parentRect = parentElement.getBoundingClientRect();

	const relativeTop = rect.top - parentRect.top;
	const relativeLeft = rect.left - parentRect.left;

	inner.style.position = isActive ? 'fixed': 'absolute';
	inner.style.left = isActive ? `${relativeLeft}px`: '';
	inner.style.width = 'auto';

	const spaceToBottom = window.innerHeight - rect.top;
	const elTop = window.innerHeight - 250;

	if(spaceToBottom < 250) {
		inner.style.top = isActive ? `${elTop}px` : '-2px';
	} else {
		inner.style.top = isActive ? `${relativeTop}px` : '-2px';
	}
}

function setState(select, state) {
	const list = select.querySelector('.select__list');
	const CLASS_EXPANDED = 'select--opened';

	switch (state) {
		case true:
			console.log('open');
			select.classList.add(CLASS_EXPANDED);
			gsap.to(list,
				{
					// height: isActive ? 'auto' : 0,
					height: 'auto',
					duration: 0.3
				}
			);
			break;

		case false:
			toggleFixedSelect(select, false);
			select.classList.remove(CLASS_EXPANDED);
			gsap.to(list,
				{
					height: 0,
					duration: 0.3
				}
			);
			break;

		case -1:
			let isActive = select.classList.toggle(CLASS_EXPANDED);

			toggleFixedSelect(select, isActive);

			gsap.to(list,
				{
					height: isActive ? 'auto' : 0,
					duration: 0.3
				}
			);
			break;
	}
}

function setZindex(holder) {

	const cartRows = [...document.querySelectorAll('.cart__row')];

	if(cartRows.length > 0) {
		cartRows.forEach((row) => {
			row.style.zIndex = '1';
		});

		const currentRow = holder.closest('.cart__row');

		if(!currentRow) return;

		currentRow.style.zIndex = '200';
	}
}

export { initSelects };